(function () {
  "use strict";

  const heroSlider = document.querySelectorAll(".main-hero .swiper");
  heroSlider.forEach((sliderContainer) => {
    // Look for elements specifically inside THIS container
    const swiperParent = sliderContainer.closest(".main-hero");
    let prevBtn = swiperParent.querySelector(".slider-control .button-prev");
    let nextBtn = swiperParent.querySelector(".slider-control .button-next");
    const pagination = swiperParent.querySelector(
      ".slider-control .slider-pagination",
    );
    // const prevBtn = sliderContainer.querySelector('.ic-chevron-left').parentElement;
    // const nextBtn = sliderContainer.querySelector('.ic-chevron-right').parentElement;

    const swiper = new Swiper(sliderContainer, {
      // Basic Swiper settings
      slidesPerView: 1,
      // loop: true,

      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },

      // Navigation configuration
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "disabled",
        hiddenClass: "hidden",
        navigationDisabledClass: "navigation-disabled",
        lockClass: "lock",
      },
      pagination: {
        el: pagination,
        type: "fraction",
      },
    });
  });

  const productSlider = document.querySelectorAll(".page-gallery .swiper");
  productSlider.forEach((sliderContainer) => {
    // Look for elements specifically inside THIS container
    const pagination = sliderContainer.querySelector(".slider-pagination");

    const swiper = new Swiper(sliderContainer, {
      // Basic Swiper settings
      slidesPerView: 1,
      // loop: true,

      pagination: {
        el: pagination,
        type: "bullets",
        bulletClass: "bullet",
        bulletActiveClass: "active",
      },
    });
  });

  const collectionSliders = document.querySelectorAll(
    ".collection-slider .swiper",
  );
  collectionSliders.forEach((sliderContainer) => {
    // Look for elements specifically inside THIS container
    const swiperParent = sliderContainer.closest(".collection-slider");
    let prevBtn = swiperParent.querySelector(".button-prev");
    let nextBtn = swiperParent.querySelector(".button-next");
    // const pagination = sliderContainer.querySelector('.slider-pagination');
    // const prevBtn = sliderContainer.querySelector('.ic-chevron-left').parentElement;
    // const nextBtn = sliderContainer.querySelector('.ic-chevron-right').parentElement;

    const swiper = new Swiper(sliderContainer, {
      // Basic Swiper settings
      slidesPerView: 1.3,
      spaceBetween: 16,
      // loop: true,

      // Navigation configuration
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
        disabledClass: "disabled",
        hiddenClass: "hidden",
        navigationDisabledClass: "navigation-disabled",
        lockClass: "lock",
      },
      /*  pagination: {
                  el: pagination,
                  type: 'bullets',
                  clickable: true,
                  bulletClass: 'bullet-item',
                  bulletActiveClass: 'active',
              },*/

      // Responsive breakpoints (optional)
      breakpoints: {
        768: {
          slidesPerView: 1.3,
          spaceBetween: 16,
        },
        811: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
      },
    });
  });

  document.querySelectorAll(".info-accordion").forEach((accordion) => {
    // 1. Core element checks
    const parent = accordion.closest(".info-content");
    const closeAccordion = accordion.querySelector(
      ".accordion-head .close-accordion",
    );
    const accordionHeads = accordion.querySelectorAll(".head-item");
    const accordionContents = accordion.querySelectorAll(".content-item");

    // Safety: If there's no parent or no heads, we can't do much
    if (!parent) return;

    // 2. Add event listener only if the close button exists
    closeAccordion?.addEventListener("click", () => {
      parent.querySelector(".product-meta")?.classList.remove("hide");
      parent.querySelector(".info-description")?.classList.remove("hide");
      parent.querySelector(".divider")?.classList.remove("hide");

      accordionHeads.forEach((item) => item.classList.remove("active"));
      accordionContents.forEach((item) => item.classList.remove("open"));
    });

    accordionHeads.forEach((head, index) => {
      head.addEventListener("click", () => {
        const isActive = head.classList.contains("active");

        // Reset all
        accordionHeads.forEach((item) => item.classList.remove("active"));
        accordionContents.forEach((item) => item.classList.remove("open"));

        if (!isActive) {
          // Using optional chaining to prevent errors if these specific classes aren't in the parent
          parent.querySelector(".product-meta")?.classList.add("hide");
          parent.querySelector(".info-description")?.classList.add("hide");
          parent.querySelector(".divider")?.classList.add("hide");

          head.classList.add("active");

          // Safety check for the matching content index
          const targetContent = accordionContents[index];
          if (targetContent) {
            targetContent.classList.add("open");
          }
        }
      });
    });
  });
})();
